// extracted by mini-css-extract-plugin
module.exports = {"scrollFix":"video-module--scroll-fix--2IsfE","wrapper":"video-module--wrapper--sXhb4","iframe":"video-module--iframe--2S5ME"};